// extracted by mini-css-extract-plugin
export default {"totalLayout":"VastraPurposeOther_totalLayout__H-Sqv","SubHeading":"VastraPurposeOther_SubHeading__0yJcC","formLayout":"VastraPurposeOther_formLayout__UKccm"};